module.exports = __webpack_public_path__ + "static/media/iconCreditcard.2982f2db.svg";